import { businessReference, SITE_URL } from './business';

// Page entities reference the single business record rather than redefining it.
export const normalizePageSchema = (input, canonical, topLevel = true) => {
  if (!input || typeof input !== 'object') return input;
  if (Array.isArray(input)) return input.map((item) => normalizePageSchema(item, canonical, topLevel)).filter(Boolean);
  const type = input['@type'];
  if (type === 'LocalBusiness') return topLevel ? null : businessReference;
  if (type === 'Organization' && /groundhogs/i.test(input.name || '')) return businessReference;
  const output = {};
  Object.entries(input).forEach(([key, value]) => {
    output[key] = normalizePageSchema(value, canonical, key === '@graph');
  });
  const fragments = { Service: 'service', Article: 'article', TechArticle: 'article', FAQPage: 'faq', BreadcrumbList: 'breadcrumbs' };
  if (fragments[type]) {
    output['@id'] = `${canonical}#${fragments[type]}`;
    if (type === 'Service') output.provider = businessReference;
    if (type === 'Article' || type === 'TechArticle') {
      output.publisher = businessReference;
      output.mainEntityOfPage = { '@type': 'WebPage', '@id': canonical };
    }
  }
  return output;
};

export const serviceSchema = (name, description) => ({
  '@context': 'https://schema.org', '@type': 'Service', name, description,
  provider: businessReference,
  areaServed: [{ '@type': 'City', name: 'Thunder Bay' }, { '@type': 'AdministrativeArea', name: 'Northwestern Ontario' }]
});

export const resolveCanonical = (pathname, explicitUrl, explicitPath) => {
  const result = new URL(explicitUrl || explicitPath || pathname || '/', `${SITE_URL}/`);
  result.search = '';
  result.hash = '';
  if (result.pathname !== '/') result.pathname = result.pathname.replace(/\/+$/, '');
  return result.href;
};